const settings = {
    privacyPolicyURL: '/privacy',
    termsOfServiceURL: '/tos',
    signInSuccessURL: '/',
}

export default settings